const popupSuccess = (message) => {
  const element = createPopAlart({ message, type: 'success' });
  document.body.insertAdjacentElement('beforeend', element);
  setTimeout(() => element.remove(), 2000);
};

const popupError = (message) => {
  const element = createPopAlart({ message, type: 'error' });
  document.body.insertAdjacentElement('beforeend', element);
  setTimeout(() => element.remove(), 2000);
};

export const popupInfo = (message) => {
  const element = createPopAlart({ message, type: 'info' });
  document.body.insertAdjacentElement('beforeend', element);
  setTimeout(() => element.remove(), 2000);
};

const createPopAlart = ({
  message,
  type = 'success'
}) => {
  const box = document.createElement('div');
  const classList = {
    success: ['u-box-popAlart'],
    error: ['u-box-popAlart', '-err'],
    info: ['u-box-popAlart', '-info'],
  }
  box.classList.add(...classList[type]);
  box.insertAdjacentHTML('beforeend', `
    <div class="inner">
      <p><i class="icon-info pr5 fz125 va-m"></i>${message}</p>
    </div>
  `);
  return box;
};

export { popupSuccess, popupError };
